import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';

import { FaqsService } from '../faqs-service/faqs.service';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { FaqsSubcategory } from 'src/app/shared/models/subCategory';
import { ShellService } from 'src/app/shell/shell.service';

@Injectable({
  providedIn: 'root',
})
export class SubcategoryResolver implements Resolve<FaqsSubcategory> {
  constructor(
    private faqsService: FaqsService,
    private shellService: ShellService,
  ) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<FaqsSubcategory> {
    this.shellService.setIsLoading(true);

    enum urlTypes {
      category,
      subCategory,
    }

    const { name, parentName } = route.params;

    const type =
      state.url.toLowerCase().indexOf('subcategoria') !== -1
        ? urlTypes.subCategory
        : urlTypes.category;
    if (type === urlTypes.category) {
      return this.faqsService
        .getSubCategoriesByCategoryName(name)
        .pipe(finalize(() => this.shellService.setIsLoading(false)));
    }

    if (parentName) {
      return this.faqsService
        .getSubCategoriesFilteredByParentName(name, parentName)
        .pipe(finalize(() => this.shellService.setIsLoading(false)));
    }

    return this.faqsService
      .getSubCategoriesByName(name)
      .pipe(finalize(() => this.shellService.setIsLoading(false)));
  }
}
